var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-btn',{attrs:{"color":"teal","outlined":"","loading":_vm.loading,"text":_vm.$t('common.close'),"icon":"mdi-close"},on:{"press":_vm.press}})}
var staticRenderFns = []

export { render, staticRenderFns }